import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { environment } from "@env/environment";

@Injectable({
  providedIn: "root",
})
export class TransferService {
  constructor(private http: HttpClient) {}

  getRepositories(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.base_url}/repositories`);
  }

  transferProject(projectId: number, repositoryId: number): Observable<any> {
    return this.http.post<any>(
      `${environment.base_url}/projects/transfer/${projectId}/${repositoryId}`,
      undefined
    );
  }
}
